import $ from 'expose-loader?exposes=$,jQuery!jquery'
import { alert } from '@pnotify/core'
import { Popover } from 'bootstrap'

export function debounce(func) {
  let timer
  return function (event) {
    if (timer) clearTimeout(timer)
    timer = setTimeout(func, 100, event)
  }
}

function checkIfStringStartsWith(str, substrs) {
  return substrs.some(substr => str.startsWith(substr))
}

const themeFunctions = [
  'ajaxUpdate',
  'checkI',
  'deleteVouchers',
  'handleDomainWidgets',
  'initPhoneNumberField',
  'initCCard',
  'initNavtabs',
  'notify',
  'serviceLabel',
  'sorterUpdate',
  'switchDepartment'
]

export function parseResponse(data) {
  if (data.indexOf('<!-- {') !== 0) {
    return false
  }

  const codes = JSON.parse( data.substr(data.indexOf('<!-- ') + 4, data.indexOf('-->') - 4))

  let i = 0

  setTimeout(() => {
    for (i = 0; i < codes.ERROR.length; i++) {
      alert({
        text: codes.ERROR[i],
        type: 'error',
        hide: false,
        sticker: false,
        icon: false
      })
    }

    for (i = 0; i < codes.INFO.length; i++) {
      alert({
        text: codes.INFO[i],
        type: 'info',
        hide: false,
        sticker: false,
        icon: false
      })
    }
  }, 300)

  if (codes.EVAL) {
    for (i = 0; i < codes.EVAL.length; i++) {
      if (checkIfStringStartsWith(codes.EVAL[i], themeFunctions)) {
        const fn = new Function('theme.' + codes.EVAL[i])
        fn()
      } else {
        //alert(codes.EVAL[i])
        const fn = new Function(codes.EVAL[i])
        fn()
      }
    }
  }

  return data.substr(data.indexOf('-->') + 3, data.length)
}

export function getParameterByName(name, data) {
  name = name.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]')
  const regex = new RegExp("[\\?&]" + name + "=([^&#]*)")
  const results = regex.exec(data || window.location.search)
  if (results === null) {
    return ''
  }
  else {
    return decodeURIComponent(results[1].replace(/\+/g, ' '))
  }
}

export function isEmpty(obj) {
  if (typeof obj === 'string') {
    if (obj.length > 0)
      return false
  }
  for (let prop in obj) {
    if (obj.hasOwnProperty(prop))
      return false
  }
  return true
}

export function filterApply() {
  const list = $('#currentlist'),
    url = list.attr('href')

  $('#updater').addLoader()
  ajaxUpdate(url, {reset: true}, '#updater')
  $('.dropdown-filters').dropdown('toggle')

  return false
}

export function filterReset() {
  const list = $('#currentlist')
  let url = list.attr('href')
  $('[data-sorter-select] option:selected').removeAttr('selected')
  $('[data-sorter-select]').each(function (i, obj) {
    $(obj).val('')
    const key = $(obj).attr('name')
    url = url.replace(
      new RegExp('[&?]?' + key.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&") + '(=[^&]*)?'),
      ''
    )
  })
  $('[data-sorter-checkbox]').each(function (i, obj) {
    $(obj).prop('checked', false)
    const key = $(obj).attr('name')
    url = url.replace(
      new RegExp('[&?]?' + key.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&") + '(=[^&]*)?'),
      ''
    )
  })
  list.attr('href', url)

  $('#updater').addLoader()
  ajaxUpdate(url, {reset: true}, '#updater')
  $('.dropdown-filters').dropdown('toggle')

  return false
}

export function ajaxUpdate(url, params, update, swirl) {
  if (swirl) {
    $(update).html('<div class="w-100 text-center"><div class="loader loader-dark"></div></div>')
  }

  if (typeof params !== 'undefined' && isEmpty(params)) {
    params = {
      empty1m: 'param'
    }
  }

  $.post(url, params, data => {
    const resp = parseResponse(data)
    if (!resp) {
      $(update).html('')
      return false
    }
    else {
      const el = $(update).html(resp)
      el.trigger('ajaxupdate')
      el.find('[data-bs-toggle="popover"]').each(function() {
        new Popover(this)
      })
    }
  })
}

export const xssFormat = (value) => {
  const lt = /</g,
    gt = />/g,
    ap = /'/g,
    ic = /"/g
  value = value.toString()
    .replace(lt, '&lt;')
    .replace(gt, '&gt;')
    .replace(ap, '&#39;')
    .replace(ic, '&#34;')
  return value
}

export const uaMatch = ua => {
  ua = ua.toLowerCase()

  const match = /(chrome)[ \/]([\w.]+)/.exec(ua) ||
    /(webkit)[ \/]([\w.]+)/.exec(ua) ||
    /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(ua) ||
    /(msie) ([\w.]+)/.exec(ua) ||
    ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) ||
    []

  return {
    browser: match[1] || '',
    version: match[2] || '0'
  }
}
